import React from "react";
import {
  Grid,
  Box,
  Button,
  Modal,
} from "@mui/material";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LogoItalmundo from "assets/img/Logo-Italmundo.svg";
import IconoMensajeItal from "assets/img/IconoMensajeItal.png";

export const ModalGenerico = ({ modal, handleModalCloseClick }) => {
  const classes = useStyles();

  return (
    <Modal
      open={modal.open}
      onClose={() => handleModalCloseClick()}
      className="modal"
    >
      <Box className={classes.modalOverlay}>
        <Box className={classes.modalContent}>
          {modal.showX ? (
            <div className={classes.modalContainerX}>
              <IconButton
                className={classes.closeButtonContainer}
                onClick={() => handleModalCloseClick()}
              >
                <CloseIcon className={classes.closeButton} />
              </IconButton>
            </div>
          ) : (
            <div style={{ height: "35px" }}></div>
          )}
          <Box className={classes.modalImageContainer}>
            <img src={modal.img ? modal.img : IconoMensajeItal} alt="Modal Icon" />
          </Box>
          {modal.content ? (
            modal.content
          ) : (
            <Box className={classes.modalContentDynamic}>
              {modal.title && (
                <h3
                  className={`${classes.modalTitle} ${
                    modal.titlePink ? classes.colorPink : ""
                  }`}
                >
                  {modal.title}
                </h3>
              )}
               <div className={classes.modalMessage} dangerouslySetInnerHTML={{ __html: modal.message }} />
            </Box>
          )}
          <Box className={classes.modalBoxFooter}>
            <img src={LogoItalmundo} className={classes.modalFooterImage} />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalGenerico;
